import { mergeClasses } from "@fluentui/react-components";
import { formatMeetingTimeRange } from "apps/project-iq/components/VaultMeetingsDialog/VaultMeetingsDialog.utils";
import { useVaultMeetingChipStyles } from "./VaultMeetingChip.styles";
import { IVaultMeetingChipProps } from "./VaultMeetingChip.types";

export const VaultMeetingChip = ({
  meeting,
}: IVaultMeetingChipProps): JSX.Element => {
  const styles = useVaultMeetingChipStyles();
  const { title, hasTranscript, isSaved } = meeting;

  return (
    <li
      className={mergeClasses(styles.chip, isSaved && styles.chipSaved)}
      data-testid="vault-meeting-chip"
    >
      <p className={styles.time}>{formatMeetingTimeRange(meeting)}</p>
      <p className={styles.title}>{title}</p>
      <ul className={styles.indicators}>
        <li
          className={mergeClasses(
            styles.indicator,
            hasTranscript
              ? styles.indicatorTranscript
              : styles.indicatorNoTranscript,
          )}
        >
          {hasTranscript ? "Transcript" : "No transcript"}
        </li>
        {isSaved && (
          <li className={mergeClasses(styles.indicator, styles.indicatorSaved)}>
            Saved
          </li>
        )}
      </ul>
    </li>
  );
};
